export default __webpack_public_path__ + "static/media/2179.dea41866.png";